<template>
    <div class = "tree">
        <div class = "tree-item" v-for = "treeitem1 in data" v-bind:key = "treeitem1.id">
            <div class = "tree-item-block" @click.stop="select(treeitem1)" :class="{'tree-item-select' : selectRow == treeitem1}">
                 <span class="layui-tree-iconClick " :class="{'layui-tree-icon' : !treeitem1.isLeaf}" @click.stop="expand(treeitem1)">
                    <i class="layui-icon" :class="{'layui-icon-subtraction' : (treeitem1.expand && !treeitem1.isLeaf), ' layui-icon-addition': (!treeitem1.expand && !treeitem1.isLeaf), 'layui-icon-file': treeitem1.isLeaf}"></i>
                </span>
                <div  :class="{'layui-form-checked': treeitem1.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeitem1)">
                    <i class="layui-icon layui-icon-ok"  ></i>
                </div>
                <span class = "tree-item-txt" v-text="treeitem1.title" @mousedown.stop="dragTreeNode(treeitem1)"></span>
            </div>
             <div v-show = "treeitem1.expand" class = "tree-item tree-padding" v-for = "treeitem2 in treeitem1.children" v-bind:key = "treeitem2.id">
                <div class = "tree-item-block" @click.stop="select(treeitem2)"  :class="{'tree-item-select' : selectRow == treeitem2}">
                    <span class="layui-tree-iconClick" :class="{'layui-tree-icon' : !treeitem2.isLeaf}"  @click.stop="expand(treeitem2)">
                        <i class="layui-icon" :class="{'layui-icon-subtraction' : (treeitem2.expand && !treeitem2.isLeaf), ' layui-icon-addition': (!treeitem2.expand && !treeitem2.isLeaf), 'layui-icon-file': treeitem2.isLeaf}"></i>
                    </span>
                     <div  :class="{'layui-form-checked': treeitem2.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeitem2)">
                        <i class="layui-icon layui-icon-ok"  ></i>
                    </div>
                    <span class = "tree-item-txt " v-text="treeitem2.title" @mousedown.stop="dragTreeNode(treeitem2)"></span>
                </div>
                <div  v-show = "treeitem2.expand" class = "tree-item tree-padding" v-for = "treeitem3 in treeitem2.children" v-bind:key = "treeitem3.id">
                    <div class = "tree-item-block" @click.stop="select(treeitem3)"  :class="{'tree-item-select' : selectRow == treeitem3}">
                        <span class="layui-tree-iconClick" :class="{'layui-tree-icon' : !treeitem3.isLeaf}" @click.stop="expand(treeitem3)">
                            <i class="layui-icon" :class="{'layui-icon-subtraction' : (treeitem3.expand && !treeitem3.isLeaf), ' layui-icon-addition': (!treeitem3.expand && !treeitem3.isLeaf), 'layui-icon-file': treeitem3.isLeaf}"></i>
                        </span>
                         <div  :class="{'layui-form-checked': treeitem3.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeitem3)">
                            <i class="layui-icon layui-icon-ok"  ></i>
                        </div>
                        <span class = "tree-item-txt " v-text="treeitem3.title" @mousedown.stop="dragTreeNode(treeitem3)"></span>
                    </div>
                     <div  v-show = "treeitem3.expand" class = "tree-item tree-padding" v-for = "treeitem4 in treeitem3.children" v-bind:key = "treeitem4.id">
                        <div class = "tree-item-block" @click.stop="select(treeitem4)"  :class="{'tree-item-select' : selectRow == treeitem4}">
                            <span class="layui-tree-iconClick" :class="{'layui-tree-icon' : !treeitem4.isLeaf}"  @click.stop="expand(treeitem4)">
                                <i class="layui-icon" :class="{'layui-icon-subtraction' : (treeitem4.expand && !treeitem4.isLeaf), ' layui-icon-addition': (!treeitem4.expand && !treeitem4.isLeaf), 'layui-icon-file': treeitem4.isLeaf}"></i>
                            </span>
                            <div  :class="{'layui-form-checked': treeitem4.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeitem4)">
                                <i class="layui-icon layui-icon-ok"  ></i>
                            </div>
                            <span class = "tree-item-txt " v-text="treeitem4.title" @mousedown.stop="dragTreeNode(treeitem4)"></span>
                        </div>
                        <div  v-show = "treeitem4.expand" class = "tree-item tree-padding" v-for = "treeitem5 in treeitem4.children" v-bind:key = "treeitem5.id">
                            <div class = "tree-item-block" @click.stop="select(treeitem5)"  :class="{'tree-item-select' : selectRow == treeitem5}">
                                <span class="layui-tree-iconClick" :class="{'layui-tree-icon' : !treeitem5.isLeaf}"  @click.stop="expand(treeitem5)">
                                    <i class="layui-icon" :class="{'layui-icon-subtraction' : (treeitem5.expand && !treeitem5.isLeaf), ' layui-icon-addition': (!treeitem5.expand && !treeitem5.isLeaf), 'layui-icon-file': treeitem5.isLeaf}"></i>
                                </span>
                                <div  :class="{'layui-form-checked': treeitem5.checked}" class="layui-unselect layui-form-checkbox" lay-skin="primary" v-show="showCheck" @click.stop="check(treeitem4)">
                                    <i class="layui-icon layui-icon-ok"  ></i>
                                </div>
                                <span class = "tree-item-txt " v-text="treeitem5.title" @mousedown.stop="dragTreeNode(treeitem5)"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
     name: 'LayuiTree',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-tree-' + window.uuid();
            },
        },
        _model: {
            default: null,
            required: false
        },
        sort: {
          type: Array,
          default: () => {
              return []
          }
        },
        textField: {
            default: 'text',
            type: String
        },
        valueField: {
            default: 'value',
            type: String
        },
        idField: {
            default: '',
            type: String
        },
        parentField: {
            default: '',
            type: String
        },
        tableName: {
            default: '',
            type: String
        },
        selectFields: {
            default: '',
            type: String
        },
        condition: {
            default: () => {
                return {}
            },
            type: Object
        },
        defaultCondition: { type: Object, default: () => ({}) },
        treeHeight: {
            type: String,
        },
        showCheck: {
            type: Boolean,
            default: ()=> {
                return false;
            }
        },
        initExpandLevel: {
            type: Number,
            default : 0
        },
        isDrag: {
          type: Boolean,
          default: () =>{
            return false;
          }
        }
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data: function(){
        return {
            id: null,
            data: [],
            selectRow: {},
            checkRows: [],
            map : {},
        }
     },
   mounted(){
        var id = this.id = this.uuid();
        var element = this.el = $(this.$el);
        if(this.treeHeight && /^full-\d+$/.test(this.treeHeight)) {
             var fullHeightGap = this.treeHeight.split('-')[1];
             element.css('height', $(window).height() - fullHeightGap)
        } else {
             element.css('height', this.treeHeight);
        }
        element.attr("id", id);
        this.load();
    },
    methods: {
        select(row) {
            if(!this.showCheck) {
                this.ui_update = true;
                this.selectRow = row;
                this.$emit('_modelEvent', row[this.valueField]);
                this.$emit('treeclick', row);
            }
        },
        check(row){
            if(this.showCheck) {
                this.ui_update = true;
                if(!row.checked) {
                    row.checked = true;
                    this.checkRows.push(row);
                } else {
                    row.checked = false;
                    this.checkRows.remove(row);
                }
                var modelArr = [];
                for(var i = 0 ; i < this.checkRows.length; i++) {
                    modelArr.push(this.checkRows[i].value);
                }
                this.$emit('treecheck', this.checkRows, row);
                this.$emit('_modelEvent', modelArr.join(","));
            }
        },
        dragTreeNode(data) {
            this.$emit('treeDrag', data);
        },
        getSelectRow(){
            return this.selectRow;
        },
        load(){
            this.api.queryList(
                this.tableName,
                {p2: Object.assign({}, this.defaultCondition, this.condition), p9: this.selectFields, p10: this.sort},
                this.requestUniqueId
            ).then(response => {
                var result = response.result;
                this.data = this._arrayToTree0(result);
                this.isload = true;
                if(this._model) {
                    this.handleModel(this._model);
                }
            })
        },
        loadChildren(parent){
            var condition = {...this.defaultCondition};
            condition[this.parentField] = parent.id;
            this.api.queryList(
                this.tableName,
                {p2: condition, p9: this.selectFields, p10: this.sort},
                this.requestUniqueId
            ).then(response => {
                var result = response.result;
                if(result.length > 0) {
                    parent.children = [];
                    for(var i = 0 ; i < result.length; i++) {
                        var item = result[i];
                        parent.children.push(this.buildTreeData(item));
                    }
                } else {
                    parent.isLeaf = true;
                }
                parent.childLoad = true;
            })
        },
        reset(){
            this.selectRow = {};
            if(this.checkRows.length > 0) {
                this.checkRows.forEach((e)=>{
                    e.checked = false;
                });
            }
            this.checkRows = [];
        },
        expand(row){
            row.expand = !row.expand;
            if(row.expand && !row.childLoad){
                this.loadChildren(row);
            }
        },
        buildTreeData(item){
            var treeData = {
                id: item[this.idField],
                title: item[this.textField],
                value: item[this.valueField],
                children: [],
                _pid: item[this.parentField],
                _data: item,
                expand: false,
                checked: false,
                childLoad : false,
                isLeaf : false,
                isDrag: item[this.isDrag]
            }
            return treeData;
        },
        _arrayToTree0(array){
             var rootRows = []
             var treeRows = [];
             for (var i = 0 ; i < array.length ; i++) {
                var item = array[i];
                var id = item[this.idField];
                var treeData = this.buildTreeData(item)
                this.map[id] = treeData;
                treeRows.push(treeData)
             }

             for(var j = 0 ; j < treeRows.length; j++) {
                var treeRow = treeRows[j];
                var pid = treeRow._pid;
                if(this.map[pid]) {
                    this.map[pid]['children'].push(treeRow);
                    this.map[pid].childLoad = true;
                    treeRow._p = true;
                }
             }
            for(var k = 0 ; k < treeRows.length; k++) {
                var treeRow = treeRows[k];
                if(!treeRow._p) {
                    rootRows.push(treeRow);
                }
            }
            this.wrap(rootRows, 1)
            return rootRows;
        },
        wrap(rootRows, jb){
            for(var l = 0; l < rootRows.length; l++) {
                var row = rootRows[l];
                row.jb = jb;
                if(row.jb <= this.initExpandLevel) {
                    row.expand = true;
                }
                if(row.children && row.children.length > 0) {
                    this.wrap(row.children, jb + 1);
                }
            }
        },
        getDataByValue(value){
            for(var p in this.map) {
                var item = this.map[p];
                if(item.value == value) {
                    return item;
                }
            }
            console.log('LayuiTree 未找到节点：', value)
            return {}
        },
        handleModel(model){
            if(!this.ui_update) {
                this.selectRow = {};
                for(var k = 0; k < this.checkRows.length; k++) {
                    this.checkRows[k].checked = false;
                }
                this.checkRows = [];
                if(model) {
                    if(this.showCheck) {
                        var arr = model.split(",");
                        for(var i = 0 ; i < arr.length ; i++) {
                            var targetRow = this.getDataByValue(arr[i]);
                            targetRow.checked = true;
                            this.checkRows.push(targetRow);
                        }
                    } else {
                        this.selectRow = this.getDataByValue(model.split(',')[0]);
                    }
                }
            }
            this.ui_update = false;
        }
    },

    watch:{
        _model(value){
            if(this.isload) {
                this.handleModel(value);
            }
        }
    }
}
</script>
<style scoped>
    .tree {
       line-height: 22px;
       overflow-y: auto;
       margin: 20px 10px;
    }
    .tree-item {
      padding-left: 0px;
      cursor: pointer;

    }
    .tree-item-select {
        background-color: #eaeceb!important;
         color: blue;
    }
    .tree-item-block:hover {
        background-color: #f5f7f6!important;
        color: blue;
    }
    .tree-item-txt {
      padding: 3px 0;
      line-height: 33px;
      white-space: nowrap;
    }
    .tree-padding {
        padding-left: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/common/LayuiTree.vue